import React from 'react'
import { FC } from 'react'
import { Store } from 'redux'
import { Provider } from 'react-redux'
import { createMemoryHistory } from 'history';
import { Settings } from '../Settings/Settings'
import '../../styles/main.less'
export const history = createMemoryHistory()

const Root: FC<{ store: Store<RootState> }> = props => {
    return (<Provider store={props.store}>
        <Settings store={props.store} />
    </Provider>)
}

export { Root }
